import React from 'react';

const Keyword = ({text}) => {
    return (
        <button className='bg-[#334155] px-2 rounded-lg m-2'>{text}</button>
    );
};

export default Keyword;